import React from "react";
import Table from '../base_table';
import type { TableRef } from '../base_table';
import type { ColumnDef } from "@tanstack/react-table";
import {DeclarationPeriodEvent} from "../../shared/Types";
import { Spinner } from "@nike/eds";
import {TableMessage, TableError} from "../base_table/table-components";

interface EventsTableProps {
    tableRef: React.Ref<TableRef>;
    columns?: () => ColumnDef<DeclarationPeriodEvent, any>[];
    data: DeclarationPeriodEvent[];
    isLoading: boolean;
    error: any;
}

const TableSpinner = () => (
    <div className="noDataText">
        <Spinner className="eds-spacing--mt-8 eds-spacing--mb-8" size='large' />
    </div>
);

export const DeclarationPeriodEventsTable = React.memo(
    function DeclarationPeriodEventsTable({
        tableRef,
        columns,
        data,
        isLoading,
        error,
    }: EventsTableProps) {

        if (error) return (
            <TableError message={error.message || String(error)} />
        );

        return (
            <div className="full-height">
                <Table
                    className="events-table"
                    isNested
                    ref={tableRef}
                    columns={columns ? (columns() as any) : []}
                    data={data}
                    noDataContent={isLoading ? <TableSpinner /> : <TableMessage msg="No Events Found" />}
                    noDataText={isLoading ? "Loading events..." : "No events found."}
                />
            </div>
        );
    }
);
